import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import PhoneIcon from "@material-ui/icons/Call";

import LogoImage from "../logo-atel.png";
import LogoAmericaVoice from "../logo-av-w.svg";

const styles = {
  root: {
    flexGrow: 1
  },
  appbar: {
    maxWidth: "20"
  },
  paper: {
    textAlign: "center",
    margin: 20
  }
};

const Encabezado = props => {
  const { classes } = props;

  return (
    <div className={classes.root}>
      <AppBar position="static" color="primary" className={classes.appbar}>
        <Toolbar>
          <div style={{flex: 1, width: 100, marginRight: 10}} >
            <img src={LogoAmericaVoice} alt="America Voice Logo" height="40" />
          </div>
          <PhoneIcon className={classes.icon} style={{ fontSize: 20 }} />
          <Typography color="inherit"> +1 323 4171400 </Typography>
          <div style={{flex: 1}}/>
        </Toolbar>
      </AppBar>

      <Paper className={classes.paper} elevation={0}>
        <img src={LogoImage} alt="Atel Logo" width="120" />
      </Paper>
    </div>
  );
};

Encabezado.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Encabezado);
